<template>
  <div class="splash">
    <div class="dots">
      <span class="dot"></span>
      <span class="dot"></span>
      <span class="dot"></span>
    </div>
  </div>
</template>

<style scoped>
.splash {
  position: fixed;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--splash-bg);
  z-index: 9999;
}

.dots {
  display: flex;
  gap: 12px;
}

.dot {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: var(--splash-dot-color);
  animation: bounce 0.6s infinite ease-in-out;
}

.dot:nth-child(1) {
  animation-delay: 0s;
}
.dot:nth-child(2) {
  animation-delay: 0.2s;
}
.dot:nth-child(3) {
  animation-delay: 0.4s;
}

@keyframes bounce {
  0%, 80%, 100% {
    transform: translateY(0);
  }
  40% {
    transform: translateY(-10px); 
  }
}

:global(html[data-theme="light"]) {
  --splash-bg: #ffffff;
  --splash-dot-color: #2173e5;
}
:global(html[data-theme="dark"]) {
  --splash-bg: #0f0f10;
  --splash-dot-color: #4f9fff;
}
</style>